<app-form-view [formDataModel]="price"
    [formItems]="formItems"
    (onSave)="saveClickHandler($event)"
    (onCancel)="cancelClickHandler($event)"></app-form-view>
